type PublicEnvKey =
  | 'VUE_APP_ROOT_API'
  | 'VUE_APP_ROOT_API_V2'
  | 'VUE_APP_ROOT_API_V3'
  | 'VUE_APP_STATIC_FILES_URL'
  | 'VUE_APP_SUPPORT_EMAIL'
  | 'VUE_APP_TURNSTILE_SITE_KEY'
  | 'VUE_APP_HOTJAR_ID'
  | 'VUE_APP_SENTRY_URL'
  | 'VUE_APP_TEST_IDS'

type RuntimeConfig = Partial<Record<PublicEnvKey, string>> & { MODE: string }

declare global {
  interface Window {
    __FRONTEND_CONFIG__?: RuntimeConfig
  }
}

function runtimeConfig(): RuntimeConfig | undefined {
  const config =
    typeof window === 'undefined' ? undefined : window.__FRONTEND_CONFIG__
  if (!config && __REQUIRES_RUNTIME_CONFIG__) {
    throw new Error('Frontend runtime configuration was not loaded')
  }
  return config
}

export function publicEnv(key: PublicEnvKey): string | undefined {
  const config = runtimeConfig()
  return config ? config[key] : import.meta.env[key]
}

export function frontendMode(): string {
  return runtimeConfig()?.MODE ?? import.meta.env.MODE
}
